<template>
  <v-row align="start" justify="center" class="ma-0" fluid>
    <v-col cols="12" class="pa-0" >
      <v-toolbar height="60" dark color="error">
        <v-btn fab x-small color="white" depressed @click="onClose()">
          <v-icon class="error--text">close</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text pl-2">{{ item.name }}</v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="3" class="pa-0">
      <v-card flat tile>
        <v-card-text class="pa-0" :style="contentsHeightLeftSide">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="pa-0">
          <v-list color="transparent">
            <template v-for="(h, index) in headers">
              <v-list-item
                v-if="item.key || h.visible"
                :key="index"
                @click.stop="onSelect(h, index)"
              >
                <v-list-item-avatar>
                  <v-icon :color="selected.key == h.key ? 'primary' : 'grey'">{{ h.icon }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ h.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
      </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="9" class="pa-0">
      <v-card flat tile>
        <v-card-text class="pa-0" :style="contentsHeightLeftSide">
          <v-row class="pa-0 ma-0">
            <v-col cols="12" class="pa-0">
              <template-school
                v-if="selected.key == 'schools'"
                :item="item"
                :type="type"
                :contentsHeight="contentsHeight"
              >
              </template-school>
              <template-group
                v-if="selected.key == 'groups'"
                :school="item"
                :group="null"
                id="groups"
                :type="'edit'"
              >
              </template-group>
              <template-group
                v-if="selected.key == 'corps'"
                :school="item"
                :group="null"
                id="corps"
                :type="'edit'"
              >
              </template-group>
              <template-users
                v-if="selected.key == 'users'"
                :school="item"
                :type="'edit'"
              >
              </template-users>
              <template-scholae
                v-if="selected.key == 'scholae'"
                :school="item"
                :type="'edit'"
              >
              </template-scholae>
              <template-student-upload
                v-if="selected.key == 'students'"
                :school="item"
                :type="'edit'"
                :admin="true"
                :contentsHeight="contentsHeightStudents"
              >
              </template-student-upload>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TemplateSchool from '../user/TemplateSchool.vue'
import TemplateGroup from '../user/TemplateGroup.vue'
import TemplateUsers from '../user/TemplateUsers.vue'
import TemplateScholae from '../user/TemplateScholae.vue'
import TemplateStudentUpload from '../user/TemplateStudentUpload.vue'
Vue.component('template-school', TemplateSchool)
Vue.component('template-group', TemplateGroup)
Vue.component('template-users', TemplateUsers)
Vue.component('template-scholae', TemplateScholae)
Vue.component('template-student-upload', TemplateStudentUpload)
export default {
  computed: {
    ...mapGetters({
      windowSize: 'shared/windowSize'
    }),
    contentsHeightLeftSide () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60) + 'px;'
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60) + 'px;'
    },
    contentsHeightStudents () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 80 - 86 - 48) + 'px;'
    },
    headers () {
      return [
        {
          key: 'schools',
          type: 'contents',
          icon: 'mdi-school',
          iconClass: 'indigo white--text',
          title: '塾設定',
          subtitle: '',
          visible: true
        },
        {
          key: 'groups',
          type: 'contents',
          icon: 'mdi-school',
          iconClass: 'indigo white--text',
          title: '教室管理',
          subtitle: '',
          visible: false
        },
        {
          key: 'corps',
          type: 'contents',
          icon: 'mdi-account-group',
          iconClass: 'indigo white--text',
          title: 'グループ管理',
          subtitle: '',
          visible: false
        },
        {
          key: 'users',
          type: 'contents',
          icon: 'mdi-account',
          iconClass: 'indigo white--text',
          title: 'ユーザ管理',
          subtitle: '',
          visible: false
        },
        {
          key: 'scholae',
          type: 'contents',
          icon: 'mdi-domain',
          iconClass: 'warning white--text',
          title: '学校管理',
          subtitle: '',
          visible: false
        },
        {
          key: 'students',
          type: 'contents',
          icon: 'mdi-account-box',
          iconClass: 'error white--text',
          title: '生徒管理',
          subtitle: '',
          visible: false
        }
      ]
    }
  },
  data () {
    return {
      selected: null
    }
  },
  props: [ 'item', 'dialog', 'type' ],
  created () {
    this.selected = this.headers[0]
  },
  methods: {
    onClose () {
      this.$emit('dismissed')
    },
    onSelect (item, index) {
      this.selected = item
    }
  }
}
</script>

<style scoped>
</style>
